// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { ResendCodeAuthSignupEmailResendPostMutationRequest, ResendCodeAuthSignupEmailResendPostMutationResponse, ResendCodeAuthSignupEmailResendPost400, ResendCodeAuthSignupEmailResendPost410, ResendCodeAuthSignupEmailResendPost422, ResendCodeAuthSignupEmailResendPost429 } from "../models/emailAuthController/ResendCodeAuthSignupEmailResendPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getResendCodeAuthSignupEmailResendPostUrl() {
  const res = { method: 'POST', url: `/auth/signup/email/resend` as const }
  return res
}

/**
 * @description Resend verification code.
 * For signup flow: provide signup_token.
 * For link flow: requires authentication (uses current user_id).
 * @summary Resend Code
 * {@link /auth/signup/email/resend}
 */
export async function resendCodeAuthSignupEmailResendPost(data: ResendCodeAuthSignupEmailResendPostMutationRequest, config: Partial<RequestConfig<ResendCodeAuthSignupEmailResendPostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ResendCodeAuthSignupEmailResendPostMutationResponse, ResponseErrorConfig<ResendCodeAuthSignupEmailResendPost400 | ResendCodeAuthSignupEmailResendPost410 | ResendCodeAuthSignupEmailResendPost422 | ResendCodeAuthSignupEmailResendPost429>, ResendCodeAuthSignupEmailResendPostMutationRequest>({ method : "POST", url : getResendCodeAuthSignupEmailResendPostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}